/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hide'
export default icon
